module.exports = __webpack_public_path__ + "img/compare.6124c7ee.svg";